export const PROGRESS_STEP_LOCALE = {
    empty: 'Data is empty'
};